<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div class="container">
  <div *ngIf="data_report">
    <div *ngFor="let item of data_report">
      <div class="row justify-content-center" style="padding: 5% 0">
        <h1 class="lifedi-color" style="font-weight: bold">
          {{ item.reportname }}
        </h1>
      </div>
      <h2 style="text-decoration: underline" style="font-weight: bold; text-decoration: underline">
        {{ item.measure_name }}
      </h2>
      <h3 [innerText]="item.report_description"></h3>
    </div>
  </div>
  <div class="justify-content-center">
    <div style="position: absolute; left: -5000px">
      <canvas id="RadarChartpdf"></canvas>
    </div>
    <div style="margin: 0 auto; width: 100%; max-width: 100%;">
      <canvas id="RadarChart"></canvas>
    </div>
    <div *ngIf="data_report">
      <div *ngFor="let item of data_report">
        <div *ngFor="let group of item.data">
          <h1 [ngStyle]="{ color: group.group_color }"
            style="padding: 2% 0; text-align: center; font-weight: bold;text-decoration: underline">
            {{ group.group_name }}
          </h1>
          <div *ngFor="let data of group.psy_data" style="padding: 2% 0">
            <h2 [ngStyle]="{ color: group.group_color }" style="font-weight: bold;text-decoration: underline">
              {{ data.psy_name }}
            </h2>

            <h4 [innerText]="data.psy_description"></h4>

            <h2 [ngStyle]="{ color: group.group_color }" style="font-weight: bold">
              ท่านได้ {{data.value | number: '1.2-2'}} คะแนน
            </h2>
            <h4 style="padding-bottom: 3%;" [innerText]="data.range_description"></h4>
            <hr style="width:70%;text-align:center;">
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center; padding: 5% 0" *ngIf="data_report">
      <lifedi-btn lable="ดาวน์โหลด" (click)="downloadpdf()" customStyle="background: #005C3D; color: #FFFFFF; margin-top: 0px;
        padding: 0 25px;">
      </lifedi-btn>
    </div>
  </div>
</div>